export function maskUC(value) {
  if (value === null || value === undefined) return '';

  const stringValue = String(value);

  const digits = stringValue.replace(/\D/g, '');

  if (digits.length < 6) return digits;

  const corpo = digits.slice(0, -2);
  const dv = digits.slice(-2);

  const corpoFormatado = corpo.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return `${corpoFormatado}-${dv}`;
}